import { useState, useEffect } from 'preact/hooks';

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth, height: window.innerHeight,
  });
  const handleSize = () => {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
  };
  useEffect(() => {
    handleSize();
    window.addEventListener('resize', handleSize);
    return () => window.removeEventListener('resize', handleSize);
  }, []);

  return {
    ...windowSize,
    isMobile: windowSize.width <= 767,
    isTablet: windowSize.width <= 1023,
  };
}

export default useWindowSize;
